import Vue from 'vue';
import App from './App.vue';
import router from './router';

import 'jquery/src/jquery.js';
import 'popper.js/dist/popper.min.js';
import $ from 'jquery';

import './assets/css/styles.css';
import './assets/css/rizzkijo.css';
import * as VueGoogleMaps from 'vue2-google-maps';
import SizedBox from './components/SizedBox.vue';

// font awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUserSecret,
  faChevronRight,
  faChevronLeft,
  faFilter,
  faSort,
  faBars,
  faQrcode,
  faChevronCircleLeft,
  faSave,
  faHome,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Vuelidate from 'vuelidate';
import vueNumeralFilterInstaller from 'vue-numeral-filter';
import VueClipboard from 'vue-clipboard2';

import Toasted from 'vue-toasted';

import store from './stores/index.js';
import VueGtag from 'vue-gtag';

library.add(faUserSecret);
library.add(faChevronRight);
library.add(faChevronLeft);
library.add(faChevronCircleLeft);
library.add(faFilter);
library.add(faSort);
library.add(faSave);
library.add(faBars);
library.add(faQrcode);
library.add(faHome);

Vue.component('sized-box', SizedBox);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(vueNumeralFilterInstaller, { locale: 'en-gb' });
Vue.use(VueClipboard);
Vue.use(Toasted);

Vue.filter('rupiah', function (value) {
  if (!value) return '';
  value = value.toString();
  return value.replace(/,/g, '.');
});

Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0);

/**
 * 
import Tawk from 'vue-tawk';
Vue.use(Tawk, {
  tawkSrc: 'https://embed.tawk.to/6115f6dad6e7610a49affa14/1fcusoi43',
});
 */

Vue.use(
  VueGtag,
  {
    config: {
      id: 'AW-11030167536',
    },
  },
  router
);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAGQj8JZqzcHrxIE94gjMuZ6zWLpMIV9mo',
    libraries: 'places',
  },
});

import VueSwal from 'vue-swal';

Vue.use(VueSwal);

import onlyInt from 'vue-input-only-number';

Vue.use(onlyInt);

// VModal
import VModal from 'vue-js-modal/dist/index.nocss.js';
import 'vue-js-modal/dist/styles.css';
Vue.use(VModal, {
  dynamicDefaults: {
    height: 'auto',
    classes: 'myclass',
  },
});

import VueYouTubeEmbed from 'vue-youtube-embed';
Vue.use(VueYouTubeEmbed);

import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

Vue.use(VuePlyr, {
  plyr: {},
});

import wysiwyg from 'vue-wysiwyg';
Vue.use(wysiwyg, {});

import VueSilentbox from 'vue-silentbox';
Vue.use(VueSilentbox);

import VueCoreVideoPlayer from 'vue-core-video-player';
Vue.use(VueCoreVideoPlayer);

import VueCarousel from 'vue-carousel';
Vue.use(VueCarousel);

import PerfectScrollbar from 'vue2-perfect-scrollbar';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

Vue.use(PerfectScrollbar);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

$(window).on('scroll', function () {
  if ($(this).scrollTop() > 300) {
    $('.topbar').addClass('shrink');
  } else {
    $('.topbar').removeClass('shrink');
  }
});

$('#navbarResponsive .nav-link').on('click', function () {
  $('.navbar-collapse').removeClass('show');
});
